import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { useMantineTheme, Group, Loader, Text, Paper } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { safeValue, sqlDateToHumanDate } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import ModalWrapperWithoutFooter from "../../components/general/ModalWrapperWithoutFooter";
import InputComponent from "../../components/general/InputComponent";

const BarangNama = ({ stateData, fnOnChange }) => {

  const mountedRef = React.useRef(true);
  const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorSubmitData: 'barangNama-1',
  })

  const disabledForThisSteps = [
    utils.projectProcess.pengerjaan.value,
    utils.projectProcess.qc.value,
    utils.projectProcess.selesai.value,
    utils.projectProcess.sudah_diambil.value
  ];

  const disabledSteps = Object.keys(utils.projectProcess)
    .filter(key => disabledForThisSteps.includes(utils.projectProcess[key].value))
    .map(key => utils.projectProcess[key].value);

  const [data, setData] = React.useState({
    modalShow: false,
    modalValue: '',
    submitLoading: false,

    suggestionModal: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const submitData = (val) => {
    setData(d => ({
      ...d,
      suggestionModal: false,
      submitLoading: true,
    }))

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', stateData.projectId);
    formDT.append('project_process', stateData.projectProcess);
    formDT.append('project_is_cancel', stateData.projectIsCancel);
    formDT.append('project_barang_nama', val.trim());

    axios({
      method: 'post',
      url: BE_API_TWO + '/edit_project_barang_nama',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, submitLoading: false, modalShow: false }));

      if (response.data.flag_status === 'isset') {
        fnOnChange(val.trim());
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorSubmitData,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        submitLoading: false,
        modalShow: false,
      }))

      notifications.show({
        id: notificationId.current.errorSubmitData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  return (
    <React.Fragment>
      <InputComponent
        stateId={stateData.data.id}
        stateWithAsterisk={false}
        stateLabelFullWidth={true}
        stateLabel={
          <Group
            position="apart"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <Group noWrap spacing={6}>
              <Group noWrap spacing={0}>
                <Text>{stateData.data.label}</Text>

                {stateData.data.withAsterisk &&
                  <Text
                    sx={(tema) => ({ color: tema.colorScheme === 'light' ? tema.colors.red[6] : tema.colors.red[8] })}
                  >
                    &nbsp;*
                  </Text>
                }
              </Group>

              {data.submitLoading && <Loader size="xs" />}
            </Group>

            {Array.isArray(stateData.barangNamaSuggestion) && (stateData.barangNamaSuggestion.length > 0) && !disabledSteps.includes(stateData.projectProcess) &&
              <Text
                sx={(tema) => ({
                  cursor: 'pointer',
                  color: tema.colorScheme === 'light' ? tema.colors.blue[4] : tema.colors.blue[5],
                  '&:hover': {
                    color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[4],
                  }
                })}

                onClick={() => {
                  setData(d => ({ ...d, suggestionModal: true }));
                }}
              >
                History
              </Text>
            }
          </Group>
        }
        stateDescription='Nama Barang tidak bisa diubah jika sudah mulai masuk ke step Pengerjaan.'
        statePlaceHolder={stateData.data.placeholder}
        stateReadOnly={true}
        stateValue={safeValue(stateData.data.value, '')}
        stateError={stateData.data.error}
        stateStylesInput={{
          backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
          "&[data-disabled=true]": {
            color: theme.colorScheme === 'light' ? theme.colors.dark[9] : theme.colors.gray[0]
          }
        }}

        stateSXWrapper={{
          "& .mantine-InputWrapper-description": {
            marginBottom: '.75rem'
          }
        }}

        stateDisabled={disabledSteps.includes(stateData.projectProcess)}

        fnOnClick={() =>
          setData(d => ({
            ...d,
            modalShow: true,
            modalValue: stateData.data.value
          }))
        }
      />

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.modalShow}
        fnHide={() => setData(d => ({ ...d, modalShow: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Nama Barang').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Submit'
        stateButtonActionPx='xs'
        stateButtonActionColor="blue"
        stateButtonActionLoading={data.submitLoading}
        fnButtonAction={() => submitData(data.modalValue)}
      >
        <InputComponent
          stateId='barangNamaModalInput-1'
          stateWithAsterisk={false}
          stateLabel=''
          stateDescription=''
          statePlaceHolder='Nama Barang'
          stateReadOnly={false}
          stateValue={data.modalValue}
          stateError=''
          stateDisabled={disabledSteps.includes(stateData.projectProcess)}

          fnOnChange={(e) => setData(d => ({ ...d, modalValue: e.target.value }))}
        />
      </ModalTakeAction>

      <ModalWrapperWithoutFooter
        stateShow={data.suggestionModal}
        fnHide={() => setData(d => ({ ...d, suggestionModal: false }))}
        stateHideOnClickOutSide={true}
        stateTitle={String('History Nama Barang').toUpperCase()}
        stateWithCloseButton={true}
        stateOverlayZIndex={201}
        stateSize="md"
        stateScrollArea={true}
      >
        {Array.isArray(stateData.barangNamaSuggestion) && (stateData.barangNamaSuggestion.length > 0) &&
          Object.keys(stateData.barangNamaSuggestion).map((keyNB, indexNB) => {
            return (
              <Paper
                key={keyNB}

                p='xs'
                mb='xs'
                sx={(tema) => ({
                  backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[0] : tema.colors.dark[6],
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: tema.colorScheme === 'light' ? tema.colors.gray[3] : tema.colors.dark[4],
                  cursor: 'pointer'
                })}

                onClick={() => {
                  submitData(stateData.barangNamaSuggestion[keyNB].barang_nama);
                }}
              >
                <Text size='sm'>
                  {stateData.barangNamaSuggestion[keyNB].barang_nama}
                </Text>

                <Text size='xs' color="dimmed">
                  Tanggal Ambil {sqlDateToHumanDate({
                    stateDate: stateData.barangNamaSuggestion[keyNB].tanggal_ambil,
                    stateWithTime: false,
                    stateLang: 'id',
                    stateIsShort: false,
                    stateDay: false,
                    stateDefaultValue: ' - ',
                    stateDateType: 'day',
                    stateWithSecond: false
                  })}
                </Text>
              </Paper>
            )
          })
        }
      </ModalWrapperWithoutFooter>
    </React.Fragment>
  )
}

export default BarangNama;